// src/components/Footer.js
import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const Footer = () => {
  return (
    <footer
      className="py-5 text-white"
      style={{
        backgroundColor: "#76421aa2",
      }}
    >
      <Container>
        <Row>
        <Col md={4} className="text-center text-md-start">
          <h5 className="fw-bold">Ndlebe Msuthu Attorneys</h5>
          <p>
            Providing trusted legal services with professionalism and integrity.
          </p>
        </Col>
        <Col md={4} className="text-center text-md-start">
          <h6 className="fw-bold">Company</h6>
          <ul className="list-unstyled">
            <li>About</li>
            <li>Services</li>
            <li>Team</li>
            <li>Contact</li>
          </ul>
        </Col>
        <Col md={4} className="text-center text-md-start">
          <h6 className="fw-bold">Legal</h6>
          <ul className="list-unstyled">
            <li>Privacy Policy</li>
            <li>Terms of Service</li>
          </ul>
        </Col>

        </Row>

        {/* Divider */}
        <hr className="border-light mt-4 opacity-50" />

        {/* Bottom text */}
        <Row>
          <Col className="text-center small">
            © {new Date().getFullYear()} Ndlebe Msuthu Attorneys. All rights
            reserved. <br />
            Designed by:{" "}
            <a
              href="https://mslb-intellisoft.co.za/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#fff", textDecoration: "underline" }}
            >
              <strong>MSLB IntelliSoft</strong>
            </a>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;